import { render, staticRenderFns } from "./CheckboxWrapper.vue?vue&type=template&id=37208191&scoped=true&"
import script from "./CheckboxWrapper.vue?vue&type=script&lang=js&"
export * from "./CheckboxWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxWrapper.vue?vue&type=style&index=0&id=37208191&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37208191",
  null
  
)

export default component.exports